import { Link } from "@material-ui/core";
import { FC, useMemo } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useCheckproLinks } from "./hooks/useCheckproLinks";
import { UrlParams } from ".";

export const LinkNeoChecklists: FC = () => {
	const { auth } = useCheckproLinks();

	const { businessId, neoProjectId } =
		useParams<UrlParams>();

	const url = useMemo(() => {
		const userType = auth.user?.tipoUsuario;

		if (userType === "Administrador")
			return `/administrador/empresas/${businessId}/neo-projects/${neoProjectId}`;
		else
			return `/administrador/empresas/neo-projects/${neoProjectId}`;
	}, [auth.user, businessId, neoProjectId]);

	return (
		<Link component={NavLink} exact to={url}>
			Listas de chequeo
		</Link>
	);
};
